/**
 * @deprecated
 */
import $ from 'jquery';
import { decorateInnerElements, disposeInnerComponents } from 'fg-frontend/src/webComponents/decorate';
import { set } from 'ramda';

require('fg-frontend/plugins/jquery.universal-pagination');
const isMobile = require('ismobilejs');


/** ******************************************
 * stage list pagination
 ****************************************** */
$(document).on('STAGE_PAGINATION_ACTIVATE', () => {
  $('.js_pagination-stage').each((index, item) => {
    const $page = $(item);

    $page.universalPagination({
      listSelector: '.js_psList',
      itemSelector: '.js_psItem',
      lang: projectConfig.lang,
      nextClass: 'btn btn--primary',
      nextWrapperClass: 'buttons pagination--buttons',
      autoPreloadHistory: false,
      listTopOffset: 15,
      paginationSelector: '.js_pagination-stage',
      wrapperClass: 'pagination__wrapper',
    });
  });
}).on('ajaxComplete', () => {
  $(document).trigger('STAGE_PAGINATION_ACTIVATE');
  if ($('#js_mediaList').length) {
    decorateInnerElements(document.querySelector('#js_mediaList'));

    // Dynamický title Start
    const urlParams = (function (a) {
      if (a == '') return {};
      const b = {};
      for (let i = 0; i < a.length; ++i) {
        const p = a[i].split('=');
        if (p.length !== 2) continue;
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
      return b;
    }(window.location.search.substr(1).split('&')));

    if ((urlParams.pageNumber) && (document.getElementById('dynamicPageTitle')) && (document.querySelector('[data-page-name]'))) {
      // Titulek stránky
      const dynamicPageTitle = document.getElementById('dynamicPageTitle').getAttribute('data-dynamic-page-title');

      // Slovo "stránka"
      const documentPageTitle = document.querySelector('[data-page-name]').getAttribute('data-page-name');

      // Název Hasičovo
      const documentTitle = document.title;
      const documentTitleArray = documentTitle.split('-');
      const documentTitleLastInArray = documentTitleArray[documentTitleArray.length - 1].trim();

      let dynamicPageTitleArray = dynamicPageTitle.split('-');

      if (document.getElementById('dynamicPageTitleNumber')) {
        dynamicPageTitleArray.splice(1, 1, `${urlParams.pageNumber}.${documentPageTitle}`);
        document.getElementById('dynamicPageTitleNumber').innerText = urlParams.pageNumber;

        if (document.getElementById('dynamicPagePerexNumber')) {
          document.getElementById('dynamicPagePerexNumber').innerText = urlParams.pageNumber;
        }
      } else {
        dynamicPageTitleArray.splice(1, 0, `${urlParams.pageNumber}.${documentPageTitle}`);
        document.getElementById('dynamicPageTitle').innerText = dynamicPageTitleArray.join(' - ');

        if (document.getElementById('dynamicPagePerex')) {
          // Perex stránky
          const dynamicPagePerex = document.getElementById('dynamicPagePerex').getAttribute('data-dynamic-page-perex');
          const dynamicPagePerexArray = dynamicPagePerex.split('-');
          dynamicPagePerexArray.splice(1, 0, `${urlParams.pageNumber}.${documentPageTitle}`);
          document.getElementById('dynamicPagePerex').innerText = dynamicPagePerexArray.join(' - ');
        }
      }
      dynamicPageTitleArray = dynamicPageTitleArray.join(' - ');
      const newDocumentTitle = `${dynamicPageTitleArray} - ${documentTitleLastInArray}`;

      if (document.title !== newDocumentTitle) {
        document.title = newDocumentTitle;
      }
    }
    // Dynamický title Stop
  }
});
$(document).trigger('STAGE_PAGINATION_ACTIVATE');

if (isMobile.phone || isMobile.tablet) {
  $('body').addClass('is-mobile');
}


/*
const reviewItems = document.querySelectorAll('.review__item-lower');

reviewItems.forEach((item) => {
  const paragraph = item.querySelector('.review__text');
  const toggleButton = item.querySelector('.review__read-more');

  if (paragraph && toggleButton) {
    const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
    const paragraphHeight = paragraph.offsetHeight;
    const maxHeight = lineHeight * 5; // Výška 5 řádků
    const collapsedClass = 'review__text--collapsed';

    // Uložení textů z atributů 'data-text-more' a 'data-text-less'
    const textMore = toggleButton.getAttribute('data-text-more');
    const textLess = toggleButton.getAttribute('data-text-less');

    // Zkontrolujte, zda má text více než 5 řádků
    if (paragraphHeight > maxHeight) {
      paragraph.classList.add(collapsedClass);
      toggleButton.classList.remove('hidden');
      toggleButton.textContent = textMore;

      // Přidá posluchač události pro přepínání textu
      toggleButton.addEventListener('click', () => {
        if (paragraph.classList.contains(collapsedClass)) {
          paragraph.classList.remove(collapsedClass);
          toggleButton.textContent = textLess;
        } else {
          paragraph.classList.add(collapsedClass); // Sbalí text
          toggleButton.textContent = textMore; // Nastaví text tlačítka zpět na 'data-text-more'
        }
      });
    }
  }
});
*/


/*
// Najde všechny elementy s třídou 'review__item-lower'
const reviewItems = document.querySelectorAll('.review__item-lower');

// Pro každý nalezený element s třídou 'review__item-lower'
reviewItems.forEach((item) => {
  const paragraph = item.querySelector('.review__text');
  const toggleButton = item.querySelector('.review__read-more');

  if (paragraph && toggleButton) {
    const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
    const paragraphHeight = paragraph.offsetHeight;
    const maxHeight = lineHeight * 5; // Výška 5 řádků
    const collapsedClass = 'review__text--collapsed';

    // Zkontrolujte, zda má text více než 5 řádků
    if (paragraphHeight > maxHeight) {
      paragraph.classList.add(collapsedClass); // Přidá třídu 'review__text--collapsed'
      toggleButton.classList.remove('hidden'); // Odstraní třídu 'hidden' z tlačítka
    }
  }
});
*/


/*
// Najde všechny elementy s třídou 'review__text'
const elementsReviewText = document.querySelectorAll('.review__text');

if (elementsReviewText.length > 0) {
  // Pro každý nalezený element s třídou 'review__text'
  elementsReviewText.forEach((paragraph) => {
    const toggleButton = paragraph.nextElementSibling;
    const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
    const paragraphHeight = paragraph.offsetHeight;
    const maxHeight = lineHeight * 5; // Výška 5 řádků
    const collapsedClass = 'review__text--collapsed';

    // Zkontrolujte, zda má text více než 5 řádků
    if (paragraphHeight > maxHeight) {
      toggleButton.classList.remove('hidden'); // Zobrazit tlačítko, pokud je text delší než 5 řádků
      paragraph.classList.add(collapsedClass);

      function toggleText() {
        console.log('FUNCTION');
        if (paragraph.classList.contains(collapsedClass)) {
          toggleButton.textContent = 'Read less';
        } else {
          toggleButton.textContent = 'Read more';
        }
        paragraph.classList.toggle(collapsedClass);
      }
      console.log(toggleButton);
      toggleButton.addEventListener('click', toggleText);
    }
  });
}
*/


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
  window.q.forEach((f) => {
    $(f);
  });
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/web.js